













































import { Component, Prop, Vue } from "vue-property-decorator";
import Scoring from "@/store/modules/Scoring";
import { getModule } from "vuex-module-decorators";
import Viewpoints, { ChoiceFactorsScoreChanges } from "@/store/modules/Viewpoints";
import Users from "@/store/modules/Users";
import ScoreSliderKey from "@/components/scoring-input/ScoreSliderKey.vue";
import ScoringKeys from "@/store/modules/ScoringKeys";
import WorkspaceOptions from "@/store/modules/WorkspaceOptions";
import CommentBadge from "@/components/comments/CommentBadge.vue";
import { ResourceType } from "@/store/modules/Comments";
import Choices from "@/store/modules/Choices";
import { Factor, FactorGroup } from "@/api/model/FactorResource";
import Modelling from "@/store/modules/Modelling";
import { Viewpoint } from "@/api/model/Viewpoint";

const viewpointsModule = getModule(Viewpoints);
const usersModule = getModule(Users)
const scoringModule = getModule(Scoring)
const scoringKeyModule = getModule(ScoringKeys);
const workspaceOptionsModule = getModule(WorkspaceOptions)
const modellingModule = getModule(Modelling);
const choicesModule = getModule(Choices);
@Component({components: {CommentBadge, ScoringSliderSelect: ScoreSliderKey}})
export default class ViewpointFactorScoreGrowingTable extends Vue {

    @Prop()
    decisionId: string;

    @Prop()
    viewpoint!: Viewpoint;

    @Prop()
    tableFactorGroup!: FactorGroup;

    @Prop()
    row!: number;

    @Prop()
    choiceId!: string;

    @Prop({default: (() => true)})
    displayScoringKey!: boolean;

    @Prop({default: 150, type: Number})
    columnWidth!: number;

    @Prop({default: false, type: Boolean})
    disabled!: boolean;

    private submitting = false;
    get scoreWidth(){
        return this.columnWidth- 64;
    }
    
    get sliderWidth(){
        return this.columnWidth -44;
    }

    get commentsVisibility() {
        return workspaceOptionsModule.commentsVisibility;
    }

    get isOwner() {
        return usersModule.currentUserProfile && this.viewpoint.ownerUserId === usersModule.currentUserProfile.userId
    }

    get tableResourceId() {
        return this.tableFactorGroup.id;
    }

    get factorResources() {
        return modellingModule.publishedModelFactorResources;
    }

    get autoCalc() {
        return workspaceOptionsModule.autoCalc;
    }

    get tableFactors() {
        if (!this.tableFactorGroup || !this.factorResources) return [];
        return (this.tableFactorGroup.childrenIds || [])
            .map(id => this.factorResources[id])
    }

    get resource() {
        if (this.viewpoint) {
            return {
                name: this.viewpoint.name,
                id: this.viewpoint.viewpointId,
                type: ResourceType.VIEWPOINT
            }
        }
    }

    get secondaryResource() {
        if (getModule(Choices).choices[this.choiceId]) {
            return {
                id: this.choiceId,
                type: ResourceType.CHOICE,
                name: getModule(Choices).choices[this.choiceId].name
            }
        }
    }

    get tertiaryResource() {
        if (this.tableFactorGroup) {
            return {
                id: this.tableResourceId + "-" + this.row,
                type: ResourceType.FACTOR,
                name: this.tableFactorGroup.name
            }
        }
    }


    get invalidatedStatus() {
        return scoringModule.invalidatedViewpointScoring[this.viewpoint.viewpointId];
    }

    get displayScoreBar() {
        return workspaceOptionsModule.scoreBarVisibility;
    }

    get displayScoringKeysWorkspaceOption() {
        return workspaceOptionsModule.scoringKeyVisibility
    }

    get numApplicableFactors() {
        if (!this.choiceScoreData || !this.choiceScoreData.choiceFactorScores || !this.tableFactorGroup) return 0;
        let choiceFactors = this.choiceScoreData.choiceFactorScores
        return this.tableFactors.map(tf => choiceFactors[tf.id]).filter(tf => tf.weight > 0).length;
    }

    get name() {
        if (this.tableFactorGroup) return this.tableFactorGroup.name;
    }

    get choiceScoreData() {
        if (scoringModule.viewpointScores[this.viewpoint.viewpointId]) {
            return scoringModule.viewpointScores[this.viewpoint.viewpointId].choiceScores[this.choiceId]
        }
    }

    get score() {

        if (!this.choiceScoreData || !this.choiceScoreData.choiceFactorScores || !this.tableFactorGroup) return null;
        let choiceFactors = this.choiceScoreData.choiceFactorScores
        let sumScore = this.tableFactors
            .map(tf => choiceFactors[tf.id])
            .filter(tf => tf.weight > 0)
            .map(fs =>
                this.choiceScoreData.choiceFactorScores
                && this.choiceScoreData.choiceFactorScores[fs.id]
                && this.choiceScoreData.choiceFactorScores[fs.id].scores
                    ? this.choiceScoreData.choiceFactorScores[fs.id].scores || []
                    : fs.scores || []
            )
            .map(ss => ss[this.row] || 0)
            .reduce((a, b) => a + b, 0);
        return sumScore / this.numApplicableFactors;

    }


    get viewpointChoiceFactorResources() {
        if (viewpointsModule.viewpointChoiceFactorResource[this.viewpoint.viewpointId]
            && viewpointsModule.viewpointChoiceFactorResource[this.viewpoint.viewpointId][this.choiceId]) {
            return viewpointsModule.viewpointChoiceFactorResource[this.viewpoint.viewpointId][this.choiceId] || {}
        }
        return {};
    }

    get tableViewpointFactors() {
        if (viewpointsModule.viewpointFactorResources[this.viewpoint.viewpointId]) {
            return this.tableFactorGroup.childrenIds
                .map(fId => viewpointsModule.viewpointFactorResources[this.viewpoint.viewpointId][fId])
                .filter(vf => vf)
        }
    }

    get weight() {
        let viewpointFactors = this.tableViewpointFactors;
        if (!viewpointFactors || viewpointFactors.length !== this.tableFactors.length) return true;
        for (let vf of viewpointFactors) {
            if (!vf || !vf.numWeightingDots || vf.numWeightingDots > 0) return true;
        }
        return false
    }


    get viewpointScoringKeys() {
        return scoringKeyModule.viewpointScoringKeyDefinitions[this.viewpoint.viewpointId]
    }

    get scoringKey() {
        if (!this.displayScoringKey || this.tableFactorGroup == null || !this.displayScoringKeysWorkspaceOption) return null;
        let scoringKeys
        if (this.viewpointScoringKeys) {
            scoringKeys = this.viewpointScoringKeys[this.tableResourceId]
        } else {
            return null;
        }
        if (scoringKeys) {
            return scoringKeys.scoringKeys;
        }
    }
    // get style based on the bar visibility
    get commentStyle(){
        if (this.displayScoreBar){
            return 'margin-top:16px';
        }
        else{
            return 'margin-top:4px';
        }
    }

    get editComments() {
        return workspaceOptionsModule.editComments;
    }

    private async submitUserScore(userScore: number) {
        if (userScore === this.score
            || !this.choiceScoreData
            || !this.tableFactorGroup
            || !this.factorResources) return;

        let choiceFactors = this.choiceScoreData.choiceFactorScores

        let newScores = this.tableFactors
            .map(tf => choiceFactors[tf.id])
            .filter(tf => tf.weight > 0)
            .map(f => {
                let factor = this.factorResources[f.id] as Factor
                let choiceData = choicesModule.choices[this.choiceId]
                let data = factor.dataField ? choiceData[factor.dataField] ? choiceData[factor.dataField] : [] : [];
                let scores

                if (this.viewpointChoiceFactorResources && this.viewpointChoiceFactorResources[f.id]
                    && this.viewpointChoiceFactorResources[f.id].scores) {
                    //Existing user scores have been made
                    scores = this.viewpointChoiceFactorResources[f.id].scores
                } else {
                    //Use the system scores
                    scores = f.scores
                }

                if (!scores) {
                    scores = new Array(data.length).fill(0);
                } else if (scores.length < data.length) {
                    while (scores.length < data.length) {
                        scores.push(0);
                    }
                } else if (scores.length > data.length) {
                    scores.splice(data.length, data.length)
                }
                scores[this.row] = userScore;
                return {
                    factorId: f.id,
                    scores: scores
                }
            })

        let payload: ChoiceFactorsScoreChanges = {
            viewpointId: this.viewpoint.viewpointId,
            choiceId: this.choiceId,
            scores: newScores
        };
        if(this.autoCalc){
            this.submitting = true;
        }
        try {
            await viewpointsModule.putViewpointChoiceFactorScores(payload)
        } catch (e) {

        }
        this.submitting = false;

    }

}
